// extracted by mini-css-extract-plugin
export default {"paper":"DropdownPane_paper__0TE+d","paperVisible":"DropdownPane_paperVisible__eaeWV"};